import React, { useEffect, useState } from "react";
import Button from "../button/Button";
import { useNavigate } from "react-router-dom";
import winGif from "../../assets/win1.gif";
import loseGif from "../../assets/lose.gif";
import { randomTextGenerator } from "../../utils";
import { AnimatePresence } from "framer-motion";
import { FullModal } from "../../modules/world/rmc/modals/fullModal";

function GenericGameOverPrompt({
  actionType,
  retry,
  handleResume,
  closeModal,
  status,
  isOpen,
  color,
}) {
  const navigate = useNavigate();
  const [message, setMessage] = useState();

  const lossMessages = [
    "And the award for the most spectacular defeat goes to... you!",
    "You're like a magician, making victory disappear every time.",
    "Keep aiming for the stars, even if you keep hitting the ground.",
    "Well, at least you're consistent in your inconsistency.",
    "Not everyone can be a winner. And by 'not everyone,' I mean you.",
    "You're really testing the limits of how many times one can lose in a row.",
    "You're on fire... just not in the winning department.",
    "You're making losing look easy!",
  ];

  const winMessages = [
    "You've conquered the game! But can you do it again?",
    "You've won! Now go bask in the glory of pixels and code.",
    "Victory is yours! For now... until the next round.",
    "You've won! Time to update your resume with 'Master Gamer.'",
    "Behold, the victor emerges from the chaos!",
  ];

  const displayMessage = () => {
    if (status)
      return (
        <div className="flex flex-col items-center">
          <img
            className="max-w-[200px] mx-auto"
            src={winGif}
            alt="gif"
            loading="lazy"
          />
          <p className="my-2 text-center text-xl font-bold text-primary-650">
            You Won!
          </p>
          <p className="font-medium text-center text-[#FFFFFF80]">
            {randomTextGenerator(winMessages)}
          </p>
        </div>
      );
    else
      return (
        <div className="flex flex-col items-center">
          <img
            className="max-w-[200px] mx-auto"
            src={loseGif}
            alt="gif"
            loading="lazy"
          />
          <p className="my-2 text-center text-xl font-bold text-white">
            Game Over
          </p>
          <p className="font-medium text-center text-[#FFFFFF80]">
            {randomTextGenerator(lossMessages)}
          </p>
        </div>
      );
  };

  const displayEndMessage = () => (
    <div className="flex flex-col items-center">
      <ExitIcon />
      <p className="my-2 text-center text-xl font-bold text-white">
        Leaving Already?
      </p>
      <p className="font-medium text-center text-[#FFFFFF80]">
        You can still continue playing!
      </p>
    </div>
  );

  useEffect(() => {
    setMessage(displayMessage());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <AnimatePresence>
      {isOpen && (
        <FullModal
          className="h-[440px] fixed inset-x-0 bottom-0 z-[4000] bg-[#111522] animate-slide-up 480:max-w-[440px] 480:mx-auto rounded-t-[20px]"
          onClose={closeModal}
          showCloseIcon
        >
          <div className="px-5 pt-10 pb-6 flex flex-col items-center">
            {actionType === "end" ? displayEndMessage() : message}

            <div className="w-full flex flex-col gap-5 mt-10">
              <Button
                onClick={() => {
                  if (actionType !== "end") {
                    retry();
                    closeModal();
                  }
                  if (actionType === "end") {
                    handleResume();
                    closeModal();
                  }
                }}
                text={actionType === "end" ? "No, Continue Playing" : status ? "Play Again" : "Retry"}
                className={
                  color === "#43a9a8"
                    ? "text-lg py-[18px] custom-gradients"
                    : color
                    ? "text-lg py-[18px]"
                    : status
                    ? "text-lg py-[18px] !bg-primary-650"
                    : "text-lg py-[18px] !bg-[#E92932]"
                }
                style={color && color !== "#43a9a8" ? { background: color } : undefined}
              />
              <Button
                onClick={() => navigate(-1)}
                text={actionType === "end" ? "Yes, Leave Game" : "End Game"}
                className="text-lg py-[18px]"
                style={{
                  background: actionType === "end" ? "#E92932" : "#1A1F33",
                }}
              />
            </div>
          </div>
        </FullModal>
      )}
    </AnimatePresence>
  );
}

export default GenericGameOverPrompt;

const ExitIcon = () => {
  return (
    <svg
      width="100"
      height="100"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V5C3 4.46957 3.21071 3.96086 3.58579 3.58579C3.96086 3.21071 4.46957 3 5 3H9"
        stroke="#E92932"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16 17L21 12L16 7"
        stroke="#E92932"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21 12H9"
        stroke="#E92932"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
